/**
 *  Mobile swiping carousel player for presentations and documents
 *  Inherits from mobile_base_player.js
 */
import MobileBasePlayer from './mobile_base_player';
import YtubeSlide from "./ytube_slide";
import '../vendor/jquery.lazyload';
import Hammer from 'hammerjs'

const SWIPE_THRESHOLD = 75;

function MobileSwipingPlayer(config) {
  if (typeof config === "undefined") {
    return;
  }

  this.config = config;
  this.init();
}

MobileSwipingPlayer.prototype = new MobileBasePlayer();

/**
 * init() initializes the mobile swipe player.
 *   - sets instance variables
 *   - caches selectors
 *   - initializes hammer.js object
 */
MobileSwipingPlayer.prototype.init = function () {
  var self = this;
  MobileBasePlayer.prototype.init.call(this);
  this.loadMetaJS();

  this.sidebarWidthPercentage =
    this.config.slideshowType === "document" ? 0.3 : 0.15;
  this.index = this.config.start_slide > 1 ? this.config.start_slide - 1 : 0;

  /**
   *  For information overlay
   *  */

  // Set clips counts
  this.clipsCount = slideshare_object.slideshow.clip_counts || {};

  this.startX = 0;
  this.mouseUp = false; // This is necessary to handle tap event correctly

  // this.index + 1 is the initial slide number
  $('.j-current-slide').text(this.index + 1);
  $('.j-total-slides').text(this.totalSlides);
  $('#mobile-clip-button .j-clips-count').text(this.clipsCount[this.index + 1]);

  // Player controls
  this.panning = false;
  this.pinching = false;

  this.$container
    .hammer({
      drag_lock_to_axis: false,
      swipe_time: 5000,
      swipe_min_distance: 50,
      swipe_velocity: 0.1,
    })
    .on(
      "pan panstart panend pinch pinchstart pinchend",
      
      function (e) {
        if (self.gesturesBlocked) return;
        if (self.$overlay.hasClass('visible')) self.$overlay.removeClass('visible')
        self.handleHammer(e, self);
      }
    )

    this.slideshow = window.slideshare_mobile_object.slideshow
    this.slideshowCategories = window.slideshare_mobile_object.slideshow_categories
  
    this.commonEventOptions = {
      slideshow_id: this.slideshow.slideshowId,
      slideshow_created_at: this.slideshow.createdAt,
      slideshow_category: this.slideshowCategories[0] ? this.slideshowCategories[0].slideshow_category.url : null,
      slideshow_language: this.slideshow.language,
      slideshow_format: this.slideshow.slideshowType
    }
};

MobileSwipingPlayer.prototype.getAbTestValueByName = function (abTestName) {
  return (
    (window.slideshare_object && slideshare_object.nwayTestAssignments &&
      slideshare_object.nwayTestAssignments[abTestName]) ||
    'control'
  );
};

MobileSwipingPlayer.prototype.trackEvent = function(name, options) {
  if (typeof amplitude !== 'undefined') { 
    amplitude.getInstance().logEvent(name, options)
  }
}

/**
 * setupStartSlide() loads the start slide as passed in player config.
 */
MobileSwipingPlayer.prototype.setupStartSlide = function () {
  var startSlideNum = this.config.start_slide || 1,
    startSlideIndex = startSlideNum - 1;

  // Force load of landing slides
  this.loadSlide(startSlideIndex);
  this.loadSlide(startSlideIndex - 1);
  this.loadSlide(startSlideIndex + 1);

  this.index = startSlideIndex
  startSlideIndex > 0 && this.goToSlide(startSlideIndex);
};

/**
 * bindEvents() binds all the necessary callbacks used by mobile swipe player.
 */
MobileSwipingPlayer.prototype.bindEvents = function () {
  var self = this;

  $(".j-lazy-preload").lazyload({
    event: "pageReady",
    skip_invisible: false,
  });

  $(window).on("load", function () {
    self.setupStartSlide();

    // Hold off on loading sidebar images allocating bandwidth to load slides,
    // this will not prevent the images from loading if the user manually opens
    // the sidebar
    setTimeout(function () {
      $(".j-lazy-preload").trigger("pageReady");
    }, 2000);
  });

  $(window).on("resize", function (e) {
    // Stop resize triggers if handling gestures through hammer
    if (self.panning || self.pinching) return;

    // Small hack: Stop handling resize if last gesture handling finish
    // happened less than 200 ms from now
    var now = Date.now();
    if (now - self.lastGestureEnd) return;

    self.togglePlayerLayout();
    // Hack for phones who's viewport doesn't update before toggling layout
    window.setTimeout(function () {
      self.togglePlayerLayout();
    }, 500);
  });

  $(window).on("scroll", function () {
    if (self.orientation === "landscape") {
      self.togglePlayerLayout();
    }
  });

  $(".preview_img").on("click", function () {
    self.gaTracking("sidebar_thumbnail_clicked", self.index);
  });

  $(".j-slide-counter").on("click", function (e) {
    e.preventDefault();
    self.toggleSidebar();
  });

  $(".j-sunpass").on("click", function () {
    var $el = $(this);
    $el.removeClass("active");
    self.gaTracking("sunpass", $el.data("ga") + "_clicked");
  });

  $(".j-sunpass")
    .bind("touchstart", function () {
      $(this).addClass("fake-active");
    })
    .bind("touchend", function () {
      $(this).removeClass("fake-active");
    });

  
  // For mobile, support tap
  $('.mobile-player .player-container').on('tap', function (event) {
    self.toggleInformationOverlay();
    self.isTapEvent = true;
  })

  // For desktop, use mouseup/mousedown
  $('.mobile-player .player-container').on("mousedown", function(event) {
    self.startX = event.pageX;
  });
  $('.mobile-player .player-container').on('mouseup', function(event){
    if (self.isTapEvent) {
      self.isTapEvent = false;
      return;
    }

    var clipButton = document.getElementById('mobile-clip-button');
    var xDistance;
    // If user hasn't clicked on clip button, handle normally
    if (!clipButton || (!clipButton.contains(event.target) && clipButton !== event.target)) {
      xDistance = self.startX - event.pageX;
      if(Math.abs(xDistance) < 10){
        //button response here, only if user is not swiping
        self.toggleInformationOverlay();
      }
    }
  });
};

/**
 * Toggles overlay display status (visible / not visible)
 */
MobileBasePlayer.prototype.toggleInformationOverlay = function () {
  var $overlay = this.$overlay;

  // Remove timeout for auto-toggle
  if (this.hideTimer) {
    clearTimeout(this.hideTimer);
  }

  // Hide overlay if already visible, and return
  if ($overlay.hasClass('visible')) {
    $overlay.removeClass('visible');
    return;
  }
  var downloadButtonOnLastScreenOverlay = $(".download-cta-on-last-screen-overlay.active");
  // Not showing information Overlay when download cta overlay is active on last screen of the slideshow
  if (downloadButtonOnLastScreenOverlay.length === 0) {
    // Otherwise, show the overlay and set a timeout for auto-hiding
    $overlay.addClass('visible');
    this.hideTimer = setTimeout(function () {
      $overlay.removeClass('visible');
    }, 5000);
  }
}

/**
 * togglePlayerLayout() toggles the player layout depending on the device
 * orientation and player type. Currently, there is a different responsive
 * portrait and landscape view.
 */
MobileSwipingPlayer.prototype.togglePlayerLayout = function () {
  this.stageDistFromTop = this.$stage.offset().top;

  // Recalculates max allowed player height
  this.setMaxPlayerHeight();
  
  // This updates the offset on resize
  this.goToSlide(this.getCurrentSlideIndex());
  this.setSlideWidths();

  // Change overlay margins
  this.setPlayerHeight();

  this.$stage.show();
  this.initSlideMeasurements();
  this.$stage.addClass("loaded");
};

/**
 * updateSidebar() animates the sidebar to the current slide that's shown in
 * the viewport
 *
 * @param <Numeric> index - Zero-based index of the slide to highlight
 * @param <Boolean> scrollToThumbnail - Animate the sidebar to scroll to that
 *   thumbnail
*/
MobileSwipingPlayer.prototype.updateSidebar = function(index, scrollToThumbnail) {
  var elem = $(".preview_img[data-index='" + (index + 1) + "']");

  // TODO: cache selector
  $(".preview_img").removeClass("active");
  elem.addClass("active");

  if (scrollToThumbnail) {
    this.$sidebar.stop();
    this.$sidebar.animate(
      {
        scrollTop:
          elem.closest("section").position() &&
          elem.closest("section").position().top,
      },
      300
    );
  }
};

/**
 * loadSlide() loads the slide based on the index
 *   - Lazy load the image
 *   - Load the youtube embed video
 *
 * @param <Numeric> index - Zero-based index of the slide number to show
 */
MobileSwipingPlayer.prototype.loadSlide = function (index) {
  index = index + 1;
  if (index < 1 || index > this.totalSlides) {
    return;
  }
  var $slide = $('.lazyload[data-index="' + index + '"]');
  $slide.trigger("slideLazyLoad");
  $('.preview_img[data-index="' + index + '"]').trigger("slideLazyLoad");

  // video_hash is zero-indexed while slide index are one-indexed
  if (
    this.ytubeAPILoaded &&
    this.config.has_video &&
    this.config.video_hash[index - 1]
  ) {
    var $el = $("#slide-" + index).find(".ytube-embed");

    // Only initialize slide once
    if ($el.length > 0 && this.ytubeSlides[index] === undefined) {
      var id = $el.attr("id");
      this.ytubeSlides[index] = new YtubeSlide(id);
    }
  }
};

/**
 * next() changes the player to the next slide
 */
MobileSwipingPlayer.prototype.next = function () {
  this.hideLandscapeActionBtns();

  var originalIndex = this.getCurrentSlideIndex();
  var newIndex = originalIndex + 1;

  if (originalIndex < this.totalSlides - 1) {
    this.goToSlide(newIndex);
    this.updateSlideNumber(newIndex);
    this.updateClipsCount(newIndex);
    this.trackNextSlide(originalIndex);
    this.hideEndOfReaderContent();
    this.setCurrentSlideIndex(newIndex);
  } else {
    this.goToSlide(originalIndex);
    this.trackSlideshowEnd();
    this.showEndOfReaderContent();
  }

  this.loadImageAhead();
  $.slideshareEventManager.trigger('slidechanged', { index: newIndex + 1, force: true, mobile: true });
};

/**
 * prev() changes the player to the previous slide.
 */
MobileSwipingPlayer.prototype.prev = function () {
  this.hideLandscapeActionBtns();
  var originalIndex = this.getCurrentSlideIndex();
  var newIndex = originalIndex - 1;

  if (originalIndex > 0) {
    this.goToSlide(newIndex);
    this.updateSlideNumber(newIndex);
    this.updateClipsCount(newIndex);
    this.trackPreviousSlide(originalIndex);
    this.setCurrentSlideIndex(newIndex);
    this.hideEndOfReaderContent();
    $.slideshareEventManager.trigger('slidechanged', { index: newIndex, force: true, mobile: true });
  } else {
    this.goToSlide(originalIndex);
  }

  this.loadImageBehind();
};

/**
 * Handle pinch gesture
 */
MobileSwipingPlayer.prototype.handlePinch = function () {
  if (!this.pinchContext) return;
  
  // Get current slide
  var currentSlideIndex = this.getCurrentSlideIndex();
  var $currentSlide = this.$slides.eq(currentSlideIndex);

  // Get new transform origin
  var scale = this.pinchContext.scale;
  var offsetY = this.$container.parent().offset().top;
  var transformOriginX = this.pinchContext.initialCenterX;
  var transformOriginY = this.pinchContext.initialCenterY - offsetY;
  var transformOriginValue = `${transformOriginX}px ${transformOriginY}px`;

  // Build transform value
  var deltaX = this.pinchContext.deltaX + this.pinchContext.deltaXOffset;
  var deltaY = this.pinchContext.deltaY;
  var translateX = (deltaX) / scale;
  var translateY = deltaY / scale;
  var transformValue = `scale(${scale}) translate(${translateX}px, ${translateY}px)`;

  // Apply transformation
  var transform = {
    "-o-transform": transformValue,
    "-o-transform-origin": transformOriginValue,
    "-moz-transform": transformValue,
    "-moz-transform-origin": transformOriginValue,
    "-ms-transform": transformValue,
    "-ms-transform-origin": transformOriginValue,
    "-webkit-transform": transformValue,
    "-webkit-transform-origin": transformOriginValue,
    transform: transformValue,
    "transform-origin": transformOriginValue,
    "z-index": 100,
  };

  $currentSlide.css(transform);
}

/**
 * Track pinch initial position
 */
 MobileSwipingPlayer.prototype.savePinchInitialCenter = function (event) {
  if (!this.pinchContext) this.pinchContext = {};
  
  var screenWidth = window.innerWidth;
  var slideMargin = this.slideMarginRight;

  this.pinchContext.initialCenterY = event.gesture.center.y;
  this.pinchContext.initialCenterX = event.gesture.center.x - 2 * slideMargin;

  this.pinchContext.deltaXOffset = 0;

  if (event.gesture.center.x < 2 * slideMargin) {
    this.pinchContext.deltaXOffset = event.gesture.center.x - 3 * slideMargin;
    return;
  }

  if (event.gesture.center.x > (screenWidth - 2 * slideMargin)) {
    this.pinchContext.deltaXOffset = event.gesture.center.x - screenWidth + 3 * slideMargin;
    return;
  }
}

/**
 * Track pinch gesture
 */
MobileSwipingPlayer.prototype.updatePinchGestureTracking = function (event) {
  this.pinchContext.deltaX = event.gesture.deltaX;
  this.pinchContext.deltaY = event.gesture.deltaY;
  this.pinchContext.scale = event.gesture.scale;
}

/**
 * handleHammer() is the callback that the mobile gestures abstracted from
 * hammer.js calls. The logic for mobile gestures (i.e. swipe, drag, release,
 * pinch) are all handled here with case statements.
 *
 * @param <Object> ev - The hammer.js event with added information from the
 *   library
 * @param <Object> context - The instance of the MobileSwipingPlayer object
 */
MobileSwipingPlayer.prototype.handleHammer = function (ev, context) {
  var self = context;

  // Return if these properties are not defined
  if (!ev.type || !ev.gesture) {
    return;
  }

  ev.preventDefault();

  switch (ev.type) {
    case "pan":      
      // If user is pinching, don't handle pan
      // (pinchend executes before panend)
      if (self.pinching) break;

      var absoluteOffset = self.initialOffset + ev.gesture.deltaX;
      self.setContainerOffset(absoluteOffset);
      break;

    case "panstart":
      self.panning = true;
      self.initialOffset = self.getCurrentSlideOffset();
      self.stopAnimations();
      break;

    case "panend":
      self.panning = false;
      
      // If user is pinching, don't handle pan end
      // (pinchend executes before panend)
      if (self.pinching) {
        self.pinching = false;
        break;
      }

      if (ev.gesture.deltaX < -SWIPE_THRESHOLD) {
        self.next();
      }
      else if (ev.gesture.deltaX > SWIPE_THRESHOLD) {
        self.prev()
      }
      else {
        self.goToSlide(self.index);
      }
      self.startAnimations();
      break;
    
    case "pinch":
      self.handlePinch();
      self.updatePinchGestureTracking(ev);
      break;

    case "pinchstart":
      self.stopAnimations();
      self.pinching = true;
      self.savePinchInitialCenter(ev);
      self.updatePinchGestureTracking(ev);
      break;

    case "pinchend":
      self.lastGestureEnd = Date.now();
      self.resetZoom();
      self.startAnimations();
      break;
  }
};

/**
 * toggleSidebar() opens or closes the sidebar and adjusts the slide dimensions
 */
MobileSwipingPlayer.prototype.toggleSidebar = function () {
  this.$player.toggleClass("sidebar_visible");
  if (this.isSidebarVisible()) {
    $(".j-slide-counter").addClass("active");
    // Lazy load sidebar images
    if (this.sidebarLoaded === false) {
      $(".lazyload-sidebar").lazyload({
        container: ".sidebar",
      });
      this.sidebarLoaded = true;
      this.gaTracking("sidebar_show");
    }
  } else {
    $(".j-slide-counter").removeClass("active");
    this.gaTracking("sidebar_hide");
  }

  // Have to update the slide widths and player height since available width
  // de/increases
  this.setSlideWidths();
  this.setPlayerHeight();
};

/**
 * isSidebarVisible() returns whether the sidebar is visible
 */
MobileSwipingPlayer.prototype.isSidebarVisible = function () {
  return this.$player.hasClass("sidebar_visible");
};

/**
 * initSlideMeasurements() initializes the stage dimensions for the current
 *   orientation
 */
MobileSwipingPlayer.prototype.initSlideMeasurements = function () {
  var slide = this.$slides.first();

  this.slideHeight = slide.height();
  this.slideWidth = slide.width();
  this.slideLeftEdgeX = 0;

  this.absCenterX = slide.offset().left + this.slideWidth / 2;
  this.absCenterY = slide.offset().top + this.slideHeight / 2;
};

MobileSwipingPlayer.prototype.hideLandscapeActionBtns = function() {
  if(this.$landscapeBtns.is(':visible')) {
    this.$landscapeBtns.hide();
  }
};

MobileSwipingPlayer.prototype.setPlayerHeight = function() {
  this.$player.height(this.slideHeight);
  this.$stage.css('margin-top', '');

  // Kinda hackish way to avoid some strange flashes while loading
  var $player = this.$player;
  setTimeout(function() { $player.css('opacity', '1'); }, 300);
};

MobileSwipingPlayer.prototype.showEndOfReaderContent = function () {
  var prominentDownloadCtaEorMobileTestValue = this.getAbTestValueByName('prominentDownloadCtaEorMobile');

  if(prominentDownloadCtaEorMobileTestValue === 'download_cta_on_last_screen_overlay') {
    this.showDownloadCtaOnLastScreenOverlay();
  } else if (prominentDownloadCtaEorMobileTestValue === 'download_cta_below_reader') {
    this.showDownloadCtaBelowReader();
  } else {
    this.showSunPassBtn("next");
  }
};

MobileSwipingPlayer.prototype.showDownloadCtaOnLastScreenOverlay = function () {
  var downloadButtonOnLastScreenOverlay = $(".download-cta-on-last-screen-overlay:not(.active)");

  if (downloadButtonOnLastScreenOverlay.length > 0) {
    // iPhone/iPad and stock Android browsers can't handle fractional pixels
    this.slideWidth = /iPad|iPhone|Linux; U; Android/.test(navigator.userAgent)
      ? Math.ceil(this.slideWidth)
      : this.slideWidth;
    this.slideMarginRight = /iPad|iPhone|Linux; U; Android/.test(navigator.userAgent)
      ? Math.floor(this.slideMarginRight)
      : this.slideMarginRight;

    downloadButtonOnLastScreenOverlay.addClass('active');
    downloadButtonOnLastScreenOverlay.css("right", this.slideMarginRight);
    downloadButtonOnLastScreenOverlay.css("margin-right", this.slideMarginRight);
    downloadButtonOnLastScreenOverlay.css("width", this.slideWidth);
    downloadButtonOnLastScreenOverlay.css("height",this.slideHeight);
  }

  
  $(".slideshow-mobile-nav").css("display", 'none');
  $(".download-cta-on-last-screen-overlay-test").css("display", 'flex');

  var downloadCtaWithoutLikeMobileTestValue = this.getAbTestValueByName('downloadCtaWithoutLikeMobile');
  if (downloadCtaWithoutLikeMobileTestValue === 'download_cta_without_like') {
    $(".prominent-download-without-like").css("display", 'none');
  }

  this.trackEvent('end_of_reading_last_screen_overlay', this.commonEventOptions);
};

MobileSwipingPlayer.prototype.showDownloadCtaBelowReader = function () {
  var $el = $(".download-cta-below-reader:not(.active)");

  if ($el.length > 0) {
    this.slideMarginRight = /iPad|iPhone|Linux; U; Android/.test(navigator.userAgent)
      ? Math.floor(this.slideMarginRight)
      : this.slideMarginRight;
    $el.addClass('active');
    $el.css("right", this.slideMarginRight);
    $el.css("margin-right", this.slideMarginRight);
    $el.css("height",this.slideHeight);
  }

  $(".slideshow-mobile-nav").css("display", 'none');
  $(".download-cta-below-reader-test").css("display", 'flex');

  this.trackEvent('end_of_reading_partial_overlay', this.commonEventOptions);
};

/**
 * showSunPassBtn() shows the "sunpass" button to go to next/prev slideshow
 * in related. Currently, we only do this for next.
 *
 * @param <String> selector - CSS selector of sunpass btn ('next' or 'prev')
 **/
MobileSwipingPlayer.prototype.showSunPassBtn = function (selector) {
  var $el = $(".j-sunpass:not(.active)." + selector);
  if ($el.length > 0) {
    $el.addClass("active");

    this.trackEvent('next_slideshare_button', this.commonEventOptions);
  }
};


MobileSwipingPlayer.prototype.hideEndOfReaderContent = function () {
  var prominentDownloadCtaEorMobileTestValue = this.getAbTestValueByName('prominentDownloadCtaEorMobile');

  if(prominentDownloadCtaEorMobileTestValue === 'download_cta_on_last_screen_overlay') {
    this.hideDownloadCtaOnLastScreenOverlay();
  } else if (prominentDownloadCtaEorMobileTestValue === 'download_cta_below_reader') {
    this.hideDownloadCtaBelowReader();
  } else {
    this.hideSunPassBtn();
  }
};

MobileSwipingPlayer.prototype.hideDownloadCtaOnLastScreenOverlay = function () {
  var downloadButtonOnLastScreenOverlay = $(".download-cta-on-last-screen-overlay");
  if (downloadButtonOnLastScreenOverlay.length > 0) {
    downloadButtonOnLastScreenOverlay.removeClass('active');
    downloadButtonOnLastScreenOverlay.css("right", '-900px');
  }

  var downloadCtaWithoutLikeMobileTestValue = this.getAbTestValueByName('downloadCtaWithoutLikeMobile');
  if (downloadCtaWithoutLikeMobileTestValue === 'download_cta_without_like') {
    $(".prominent-download-without-like").css("display", 'flex');
  }

  $(".slideshow-mobile-nav").css("display", 'flex');
  $(".download-cta-on-last-screen-overlay-test").css("display", "none");
};

MobileSwipingPlayer.prototype.hideDownloadCtaBelowReader = function () {
  var $el = $(".download-cta-below-reader");
  if ($el.length > 0) {
    $el.removeClass('active');
    $el.css("right", '-145px');
  }

  $(".slideshow-mobile-nav").css("display", 'flex');
  $(".download-cta-below-reader-test").css("display", "none");
};

MobileSwipingPlayer.prototype.hideSunPassBtn = function () {
  var $el = $(".j-sunpass.active");
  if ($el.length > 0) {
    $el.removeClass("active");
    this.gaTracking("sunpass", $el.data("ga") + "_hide");
  }
};

/**
 * Get current slide index
 */
MobileSwipingPlayer.prototype.getCurrentSlideIndex = function () {
  return this.index;
}

/**
 * Set current slide index
 */
MobileSwipingPlayer.prototype.setCurrentSlideIndex = function (newIndex) {
  this.index = newIndex;
}

/**
 * setContainerOffset() offsets the slide container based the current slide's
 * offset relative to the parent
 *
 * @param <Numeric> offset - Offset of the slide container in pixels
 */
MobileSwipingPlayer.prototype.setContainerOffset = function (absoluteOffset) {
  var transformVal = "translateX(" + absoluteOffset + "px)";
  var transformCss = {
    "-moz-transform": transformVal,
    "-ms-transform": transformVal,
    "-o-transform": transformVal,
    "-webkit-transform": transformVal,
    transform: transformVal,
  };
  this.$container.css(transformCss);
};

/**
 * Go to target slide
 * Does not check if slide is between the bounds
 */
MobileSwipingPlayer.prototype.goToSlide = function (index) {
  var offset = this.getSlideOffset(index);
  var transformVal = "translateX(" + offset + "px)";
  var transformCss = {
    "-moz-transform": transformVal,
    "-ms-transform": transformVal,
    "-o-transform": transformVal,
    "-webkit-transform": transformVal,
    transform: transformVal,
  };
  this.$container.css(transformCss);
};

/**
 * Get target slide relative offset (to parent)
 */
MobileSwipingPlayer.prototype.getSlideOffset = function (index) {
  return -(this.$slides.eq(index).position().left);
};

/**
 * Get current slide relative offset (to parent)
 */
 MobileSwipingPlayer.prototype.getCurrentSlideOffset = function () {
  return this.getSlideOffset(this.index);
};

/**
 * Load images ahead
 */
MobileSwipingPlayer.prototype.loadImageAhead = function () {
  this.loadImage(this.index + 3);
};

/**
 * Load images behind
 */
MobileSwipingPlayer.prototype.loadImageBehind = function () {
  this.loadImage(this.index - 3);
};

/**
 * Lazy load image by setting src attribute
 */
MobileSwipingPlayer.prototype.loadImage = function (index) {
  // Set source of images ahead if necessary
  var $slideAhead = $('#slide-' + index)
  if ($slideAhead.length !== 0) {
    if ($slideAhead.attr('src') === '') {
      $slideAhead.attr('src', $slideAhead.data('original'));
    }
  }
};

/**
 * Update current slide number in HUD
 */
MobileSwipingPlayer.prototype.updateSlideNumber = function (newIndex) {
  $('.j-current-slide').text(newIndex + 1);
};

/**
 * Update clips count in HUD
 */
 MobileSwipingPlayer.prototype.updateClipsCount = function (newIndex) {
  var clips = this.clipsCount[newIndex + 1];
  if (clips && clips !== 0) {
    $('.j-clips-count').text(clips);
  }
  else {
    $('.j-clips-count').text(0);
  }
};

/**
 * Track next slide
 */
MobileSwipingPlayer.prototype.trackNextSlide = function (index) {
  if (index > this.maxSlideConsumed) {
    this.maxSlideConsumed = index;
    this.gaTracking("next_slide_" + this.orientation, index);
  }
}

/**
 * Track previous slide
 */
 MobileSwipingPlayer.prototype.trackPreviousSlide = function (index) {
  this.gaTracking("prev_slide_" + this.orientation, index);
}

/**
 * Track slideshow end
 */
MobileSwipingPlayer.prototype.trackSlideshowEnd = function (index) {
  // Only track slideshow_end event once
  if (this.isSlideshowEnd) return;

  this.isSlideshowEnd = true;
  this.gaTracking("slideshow_end");
}

/**
 * Reset zoom
 */
MobileSwipingPlayer.prototype.resetZoom = function () {
  // Get current slide
  var currentSlideIndex = this.getCurrentSlideIndex();
  var $currentSlide = this.$slides.eq(currentSlideIndex);

  $currentSlide.css({
    transform: 'scale(1) translate(0px, 0px)',
    "-o-transform": 'scale(1) translate(0px, 0px)',
    "-moz-transform": 'scale(1) translate(0px, 0px)',
    "-ms-transform": 'scale(1) translate(0px, 0px)',
    "-webkit-transform": 'scale(1) translate(0px, 0px)',
    "z-index": 1,
  });
}

/**
 * Handle animations
 */
MobileSwipingPlayer.prototype.stopAnimations = function () {
  this.$container.removeClass("animate");
  this.$slides.eq(this.getCurrentSlideIndex()).removeClass("animate");
}
MobileSwipingPlayer.prototype.startAnimations = function () {
  this.$container.addClass("animate");
  this.$slides.eq(this.getCurrentSlideIndex()).addClass("animate");
}

window.MobileSwipingPlayer = MobileSwipingPlayer;
export default MobileSwipingPlayer;
